document.addEventListener("DOMContentLoaded", function () {
  var roots = document.querySelectorAll(
    "[data-policy-body], .shopify-policy__body .rte, .shopify-policy__body"
  );
  if (!roots.length) return;

  var bulletRe = /^[·•●▪◦.\d]+[\s\u00a0]*/;

  function isBulletParagraph(el) {
    if (!el || el.tagName !== "P") return false;
    var text = (el.textContent || "").replace(/\u00a0/g, " ").trim();
    return /^[·•●▪◦]\s/.test(text) || /^[·•●▪◦]/.test(text);
  }

  function stripBulletHtml(html) {
    var tmp = document.createElement("div");
    tmp.innerHTML = html;
    var walker = document.createTreeWalker(tmp, NodeFilter.SHOW_TEXT);
    var node = walker.nextNode();
    while (node) {
      var next = walker.nextNode();
      var cleaned = node.nodeValue.replace(/^[·•●▪◦.\s\u00a0]+/, "");
      if (cleaned !== node.nodeValue) {
        if (cleaned) {
          node.nodeValue = cleaned;
        } else if (node.parentNode) {
          node.parentNode.removeChild(node);
        }
        break;
      }
      node = next;
    }
    return tmp.innerHTML;
  }

  roots.forEach(function (root) {
    if (root.dataset.policyFormatted === "true") return;
    root.dataset.policyFormatted = "true";

    var nodes = Array.prototype.slice.call(root.children);
    var i = 0;

    while (i < nodes.length) {
      var node = nodes[i];
      if (!isBulletParagraph(node)) {
        i += 1;
        continue;
      }

      var group = [];
      while (i < nodes.length && isBulletParagraph(nodes[i])) {
        group.push(nodes[i]);
        i += 1;
      }

      if (!group.length) continue;

      var list = document.createElement("ul");
      list.className = "page-content__pseudo-list";

      group.forEach(function (p) {
        var li = document.createElement("li");
        li.innerHTML = stripBulletHtml(p.innerHTML);
        list.appendChild(li);
      });

      root.insertBefore(list, group[0]);
      group.forEach(function (p) {
        if (p.parentNode) p.parentNode.removeChild(p);
      });
    }
  });
});
